/* src/app/app.component.scss */
.app-root {
  overflow: hidden;
}
.app-root .app-content {
  height: 100vh;
  width: 100vw;
  display: flex;
  overflow: hidden;
}
.app-root .app-content .route-container {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  width: 100%;
  overflow-y: auto;
}
.environmentLabel {
  padding: 10px;
  color: #001A33;
  text-align: center;
  background-color: #FFF;
}
.displayNone {
  display: none;
  padding: 0;
}
/*# sourceMappingURL=app.component.css.map */
